module.exports = __webpack_public_path__ + "static/media/logo.897548bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/LoginAdmin/commponents/LogoForgotPass/img/logo.svg
// module id = 1639
// module chunks = 0